// Einfache Consent-Verwaltung via localStorage
const KEY = "praxis_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setConsent(c) {
  localStorage.setItem(
    KEY,
    JSON.stringify({ ...c, ts: new Date().toISOString() })
  );
  window.dispatchEvent(new Event("consent-changed"));
}

export function hasConsent(category) {
  const c = getConsent();
  if (!c) return false;
  return !!c[category];
}

export function resetConsent() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("consent-reset"));
}

export function onConsentChange(handler) {
  window.addEventListener("consent-changed", handler);
  return () => window.removeEventListener("consent-changed", handler);
}
